import {useAppSelector} from "./redux";
import {selectCurrentUser} from "../features/users/model/selectors";
import {GUEST_ROLE_ID} from "../models/IUser";

/**
 * true, если текущий пользователь — гостевой (role_id === GUEST_ROLE_ID).
 *
 * Смотрит на РОЛЬ, а не на демо-режим: read-only UX получает любой
 * пользователь любой компании с ролью «Гостевой доступ», не только
 * демо-вход. По образцу useIsAdmin.
 */
export const useIsReadOnly = (): boolean => {
    const currentUser = useAppSelector(selectCurrentUser);
    return currentUser?.role_id === GUEST_ROLE_ID;
};
